import React from 'react';
import './Copyright.scss';

function index() {
    return (
        <div className='copyright-container'>
            <p>Copyright © 2018-2019 Contacta Abogado México, S.A. de C.V.</p>
        </div>
    )
}

export default index
